import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { chatSelector, globalStateSelector } from "../../../../../store/selector";
import { chatAction, messageAction } from "../../../../../store/action";
import "./AudioPicker.css";
import MessageScreenFooter from "../MessageScreenFooter/MessageScreenFooter";
import SelectedImages from "../ImageLibrary/SelectedImages";
import { getUUID } from "../../utils";
import { changeLastMessage, createChatEvent } from "../../../../../dialpad/service/chat.service";
import APIManager from "modules/common/apiManager";
import Header from "../ImageLibrary/Header";

const mAPI = new APIManager();

function DocumentPicker({ selectedAudio: selectedAudioFromRedux, ...props }) {
	const [CurrentAudioIndex, setCurrentAudioIndex] = useState(0);
	const [SelectedAllAudioData, setSelectedAllAudioData] = useState([]);
	const [Active, setActive] = useState(true);
	const [CustomMessage, setCustomMessage] = useState("");

	useEffect(() => {
		console.log("Here is also message ", CustomMessage);
	}, [CustomMessage]);


	useEffect(() => {
		try {
			setSelectedAllAudioData(Array.from(selectedAudioFromRedux));
		} catch (error) {
			console.log("Error in AudioPicker", error);
		}
	}, [selectedAudioFromRedux]);

	useEffect(() => {
		setActive(false);
		setTimeout(() => {
			setActive(true);
		}, 300);
	}, [CurrentAudioIndex]);

	function convertBytesToKBMBGB(bytes) {
		if (bytes < 1024) {
			return bytes + " B";
		} else if (bytes < 1024 * 1024) {
			return (bytes / 1024).toFixed(2) + " KB";
		} else if (bytes < 1024 * 1024 * 1024) {
			return (bytes / (1024 * 1024)).toFixed(2) + " MB";
		} else {
			return (bytes / (1024 * 1024 * 1024)).toFixed(2) + " GB";
		}
	}

	const closeAudioPicker = () => {
		const { dynamicUpdate } = props;
		dynamicUpdate({ data: { key: `selectedAudio`, value: [] } });
		setCurrentAudioIndex(0);
		setActive(true);
	};

	const resetState = () => {
		const { dynamicUpdate } = props;
		setSelectedAllAudioData([]);
		setCurrentAudioIndex(0);
		dynamicUpdate({ data: { key: `selectedAudio`, value: [] } });
	};


	const getPublicUrl = async (formData, uniqueId) => {
		console.log("sendpostformsent getpublicurl");
		const event = createChatEvent({ id: uniqueId, loading: 0 });
		const { retryAudio, dynamicUpdate } = props;
		window.dispatchEvent(event);
		return new Promise((res, rej) => {
			mAPI.sendPostForm(
				`chat/upload`,
				formData,
				(data) => {
					console.log("sendpostformsent", data);
					res(data);
				},
				(errorCode, data) => {
					console.log("Chat/upload", errorCode, data);
					const event = createChatEvent({ id: uniqueId, success: false });
					window.dispatchEvent(event);
					let newArray = [];
					if (
						retryAudio &&
						Array.isArray(retryAudio) &&
						retryAudio.length > 0
					) {
						newArray = [...retryAudio];
					}
					dynamicUpdate({
						data: {
							key: `retryAudio`,
							value: [
								...newArray,
								{
									file: selectedAudioFromRedux[0],
									uniqueId,
									status: "pending",
								},
							],
						},
					});
				},
				"private",
				(data) => {
					const progress = Math.round((100 * data.loaded) / data.total);
					const event = createChatEvent({ id: uniqueId, loading: progress });
					window.dispatchEvent(event);
				}
			);
		});
	};

	const sendMessage = async (e) => {
		const uniqueId = getUUID();
		const {
			configProcessor,
			messageList,
			assignedList,
			selectedAssignedList,
			dynamicUpdate,
			currentUser
		} = props;
		const mimeType = SelectedAllAudioData[0].type;
		const commonPayload = {
			from: "agent",
			timeStamp: new Date().toISOString(),
			// here are sending type mean audio
			type: "audio",
			content: {
				// here we are sending one audio only
				link: URL.createObjectURL(SelectedAllAudioData[0]),
				mimeType: mimeType,
				caption: CustomMessage,
			},
			id: uniqueId,
			loading: 0,
		};

		console.log(
			"selectedAssignedList.identifier: ",
			selectedAssignedList.identifier
		);

		const messageData = {
			userId: currentUser.userId,
			timeStamp: new Date().toISOString(),
			agent: {
				email: currentUser.email,
				name: currentUser.name,
				role: currentUser.role,
				userId: currentUser.userId,
				username: currentUser.user_name,
			},
			message: commonPayload,
		};

		dynamicUpdate({
			data: {
				key: `messageList.${selectedAssignedList.identifier}`,
				value: [
					messageData,
					...(messageList[selectedAssignedList.identifier] || []),
				],
			},
		});
		resetState();

		const formData = new FormData();
		formData.append("file", SelectedAllAudioData[0]);
		const data = await getPublicUrl(
			formData,
			uniqueId,
			selectedAssignedList.identifier
		);

		const messagePayload = {
			...commonPayload,
			content: {
				...data,
				mimeType: mimeType,
				caption: CustomMessage,
			},
		};

		configProcessor("sendPayload", {
			...selectedAssignedList,
			payloadType: "message",
			"rmq:pattern": "agent:message",
			message: {
				...(selectedAssignedList && selectedAssignedList.message),
				...messagePayload,
			},
		});
		changeLastMessage({
			list: assignedList,
			identifier: selectedAssignedList.identifier,
			receivedMessage: messagePayload,
			key: "assignedList",
		});
		closeAudioPicker();
	};

	if (SelectedAllAudioData && SelectedAllAudioData.length == 0) {
		return null;
	}

	return (
		<div className="document-picker_main">
			<div className="document-picker_header">
				<Header
					name={
						(SelectedAllAudioData &&
							SelectedAllAudioData[CurrentAudioIndex].name) ||
						""
					}
					size={
						(SelectedAllAudioData &&
							SelectedAllAudioData[CurrentAudioIndex].size) ||
						0
					}
					onClose={closeAudioPicker}
				/>
			</div>
			<div className="document-picker_body">
				<div
					className="document-picker-body_close"
					onClick={() => closeAudioPicker()}
				></div>
				<img
					src={"/images/AudioImage.svg"}
					className={` ${Active ? "active" : "non-active"
						} document-picker_image_size`}
					alt=" "
					width={350}
					style={{ maxWidth: '50vw', maxHeight: '40vh' }}
				/>
				<SelectedImages
					selectedImages={SelectedAllAudioData}
					selectImage={setCurrentAudioIndex}
					type={"document"}
					covertBytesToKBMBGB={convertBytesToKBMBGB}
				/>
			</div>
			<div className="position-absolute w-100 bottom-0">
				<MessageScreenFooter
					showAttachBtn={false}
					customSendMessage={sendMessage}
					setCustomMessage={setCustomMessage}
					setIsFileAttached={true}
				/>
			</div>
		</div>
	);
}

const stateToProps = (state) => ({
	selectedAssignedList: chatSelector.getChatDynamic(
		state,
		"selectedAssignedList"
	),
	messageList: chatSelector.getChatDynamic(state, "messageList"),
	assignedList: chatSelector.getChatDynamic(state, "assignedList"),
	selectedAudio: chatSelector.getChatDynamic(state, "selectedAudio"),
	retryAudio: chatSelector.getChatDynamic(state, "retryAudio"),
	currentUser: globalStateSelector.getDynamic(state, { key: 'currentUser' })
});

const dispatchToProps = (dispatch) => ({
	configProcessor: (type, messageData) => {
		dispatch(messageAction.configProcessor(type, messageData));
	},
	dynamicUpdate: (type, messageData) => {
		dispatch(chatAction.dynamicUpdate(type, messageData));
	},
});
export default connect(stateToProps, dispatchToProps)(DocumentPicker);



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/AudioLibrary/AudioPicker.jsx